module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/scss/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/scss/fonts/glyphicons-halflings-regular.woff2
// module chunks = styles